import React, {useEffect, useState, useRef} from "react";
import PropTypes from 'prop-types';
import {hot} from "react-hot-loader";
import css from "./App.css";
import Footer from 'common/Footer';
import StyledButton from 'common/StyledButton';
import StickyFooterLayout from 'common/StickyFooterLayout';
import ConfirmDialog from 'common/ConfirmDialog';
import useStarfishAPI from 'hooks/useStarfishAPI';
import Toast from 'common/Toast';
import Credentials from "./Credentials";
import moment from 'moment';
import {tenantTimeFormat} from "../utils/time";
import Modal from "react-modal";

const URL = '../api/success-score-configuration';

const App = ({tenantId, pageTitle}) => {
    Modal.setAppElement(document.getElementById("main-center"));

    const [isOpen, setIsOpen] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const [responseWrite, callWriteAPI] = useStarfishAPI({isNewAPI: true});
    const [responseRead, callReadAPI] = useStarfishAPI({isNewAPI: true});
    const [credentials, setCredentials] = useState([]);
    const [lastUpdatedDate, setLastUpdatedDate] = useState()
    const [lastUpdatedBy, setLastUpdatedBy] = useState('Starfish Support')
    const savedCredentials = useRef(credentials);

    const clear = () => {
        setCredentials(savedCredentials.current);
        setIsOpen(false);
    };

    const submit = () => {
        callWriteAPI(URL, {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({ "credentials": credentials})
        });
    };

    const onCheckBoxChange = (index, checked) => {
         setCredentials(arr => {
            const newCreds = [
                ...arr.slice(0, index),
                {...arr[index], checked},
                ...arr.slice(index + 1)
            ]
             return newCreds
        })
    }

    useEffect(() => {
        callReadAPI(URL + '?tenantId=' + tenantId, {
            method: "GET",
            headers: {
                Pragma: "no-cache",
                "Cache-Control": "no-cache",
                Expires: "-1"
            }
        });
    }, []);

    useEffect(() => {
        if (responseRead.success) {
            setCredentials(responseRead.data.credentials);
            savedCredentials.current = responseRead.data.credentials;
           if (responseRead.data.lastUpdatedDate) setLastUpdatedDate(moment(responseRead.data.lastUpdatedDate).format(tenantTimeFormat('date')))
            if (responseRead.data.lastName) setLastUpdatedBy(`${responseRead.data.lastName}, ${responseRead.data.firstName}`)
        } else if (responseRead.error) {
            setToastMessage(responseRead.error);
        }
    }, [responseRead]);

    useEffect(() => {
        if (responseWrite.error) {
            setToastMessage(responseWrite.error);
        } else if (responseWrite.success) {
            savedCredentials.current = credentials;
            if (responseWrite.data.lastUpdatedDate) {
                setLastUpdatedDate(moment(responseWrite.data.lastUpdatedDate).format(tenantTimeFormat('date')))
                if (responseWrite.data.lastName) setLastUpdatedBy(`${responseWrite.data.lastName}, ${responseWrite.data.firstName}`)
                else setLastUpdatedBy('Starfish Support')
            }
            setToastMessage("Configuration successfully updated.");
        }
    }, [responseWrite]);

    const getLastUpdatedDate = () => {
        if (lastUpdatedDate === null || typeof lastUpdatedDate === 'undefined') return <div/>
        else return  <div className={css['credential-detail']}>last updated {lastUpdatedDate} by {lastUpdatedBy}</div>

    }

    const getContent = () => {
       return  (
            <div className={css["container"]}>
                <div className={css["header"]}>
                    <div className={css["title"]}>{pageTitle}</div>
                    <hr/>
                    <div className={css['credentials-container']}>
                        {getLastUpdatedDate()}
                        <div className={css['section-title']}>Model and Prediction Configurations</div>
                        <div className={css['credential-detail']}><p className={css['credential-paragraph']}>Any credential selected below that a student is pursuing in the active term(s) will have a {pageTitle} created and displayed.</p>
                            <p className={css['credential-paragraph']}>Student credential value(s) are sent as part of the credential field in the student program file, <a
                                href="https://help.starfishsolutions.com/Starfish/FI3VYgGm6zb3OWi2R2d2/Help/Admin/IRC/Content/Starfish_Help/Integration/SISIntegrationReference/Course_Enrollment_and_Program_Files/Student_program.htm">more info in Help Center</a></p>
                            <p className={css['credential-note']}>Note: If an invalid credential is sent for a student that credential will not be considered for scoring.</p>
                        </div>
                        <div className={css['table-title']}>Include students pursuing these credentials:</div>
                    </div>

                    <Credentials credentialsList={credentials} onChange={onCheckBoxChange}/>
                    {toastMessage && <Toast message={toastMessage} onTimeout={() => setToastMessage("")}/>}
                    <ConfirmDialog confirmText="Clear Changes"
                                   cancelText="Cancel"
                                   headerText="Are you sure you want to clear all changes?"
                                   descriptionText="You will not be able to recover any changes you made to the configurations."
                                   isOpen={isOpen}
                                   onClose={() => {setIsOpen(false)}}
                                   onConfirm={clear} />
                </div>
            </div>
        );
    }


    const getFooter = () => {
        return (
            <Footer
                primaryButton={<StyledButton onClick={submit}>SAVE CHANGES</StyledButton>}
                secondaryButton={<StyledButton asLink onClick={() => setIsOpen(true)}>CLEAR CHANGES</StyledButton>}
            />
        )
    };
    return <StickyFooterLayout content={getContent()} footer={getFooter()}/>

};

App.propTypes = {
    tenantId: PropTypes.number.isRequired,
    pageTitle: PropTypes.string.isRequired
};

export default hot(module)(App);
